require('angular')
GoogleMapLoaderService = require('./googlemap-loader-service')

angular.module 'gnp-map', []
  .factory('GoogleMapLoaderService', GoogleMapLoaderService)



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/map/map-module.coffee